import { render, staticRenderFns } from "./TermsOfServiceDialog.vue?vue&type=template&id=1a5c69f6&scoped=true&"
import script from "./TermsOfServiceDialog.vue?vue&type=script&lang=ts&"
export * from "./TermsOfServiceDialog.vue?vue&type=script&lang=ts&"
import style0 from "./TermsOfServiceDialog.vue?vue&type=style&index=0&id=1a5c69f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5c69f6",
  null
  
)

export default component.exports